import React, {Component} from 'react';
import {BrowserRouter} from "react-router-dom";
import {PersistGate} from 'redux-persist/integration/react';
import {Provider} from "react-redux";
import {store, persistor} from "./redux/store";
import RoutesBlocks from "./routing";


class App extends Component {

  render() {
    return (
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter>
                    <RoutesBlocks/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    );
  }
}

export default App;
